import { render } from "./course-cascader.vue?vue&type=template&id=7e10d758"
import script from "./course-cascader.vue?vue&type=script&lang=js"
export * from "./course-cascader.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__